import React from 'react';

import colors from '@constants/colors';

import { IIconProps, TIconType } from '../interface';

const EditCustomColorIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='edit-icon'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M9.00001 20.25H4.5C4.30109 20.25 4.11033 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V15.3094C3.74966 15.212 3.76853 15.1155 3.80553 15.0254C3.84253 14.9353 3.89694 14.8534 3.96563 14.7844L15.2156 3.53438C15.2854 3.46352 15.3686 3.40725 15.4603 3.36883C15.5521 3.33042 15.6506 3.31064 15.75 3.31064C15.8495 3.31064 15.9479 3.33042 16.0397 3.36883C16.1314 3.40725 16.2146 3.46352 16.2844 3.53438L20.4656 7.71563C20.5365 7.78542 20.5928 7.86861 20.6312 7.96035C20.6696 8.05209 20.6894 8.15055 20.6894 8.25001C20.6894 8.34947 20.6696 8.44793 20.6312 8.53967C20.5928 8.63141 20.5365 8.7146 20.4656 8.78438L9.00001 20.25Z'
				// This is the correct code and color for the Select component.
				stroke={props?.color || colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12.75 6L18 11.25'
				// This is the correct code and color for the Select component.
				stroke={props?.color || colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M20.25 20.25H9L3.79688 15.0469'
				// This is the correct code and color for the Select component.
				stroke={props?.color || colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15.375 8.625L6.375 17.625'
				// This is the correct code and color for the Select component.
				stroke={props?.color || colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default EditCustomColorIcon;
